<template>
    <div class="term-page">
        <div class="term-content" v-if="this.term">
            <h1>{{ term.title }}</h1>
            <p>{{ term.intro }}</p>
            <primary-button @clicked="close" >Verder</primary-button>
        </div>
    </div>
</template>


<script>
import PrimaryButton from 'js/components/elements/PrimaryButton.vue'
import { getGroup, getGroupIdForCurrentUser, getCurrentTerm } from 'js/vuex/getters'

export default {
    name: 'TermIntro',
    components: { PrimaryButton },
    props: [],
    vuex: {
        getters: {
            getGroup,
            getGroupIdForCurrentUser,
            getCurrentTerm,
        },
        actions: {
            markViewed: ({ dispatch }) => dispatch('MARK_TERM_VIEWED')
        }
    },
    computed: {
        groupId: function() {
            return this.$route.params.groupId == null ? this.getGroupIdForCurrentUser : this.$route.params.groupId
        },
        term: function() {
            return this.getCurrentTerm( this.groupId )
        }
    },
    methods: {
        close: function(e) {
            e.preventDefault()
            this.$emit('close')
        }
    },
    created: function() {
        this.markViewed()
        if ( this.term == null ) {
            this.$emit('close')
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Term.vue?a577c22c